// extracted by mini-css-extract-plugin
export default {"formItemStyles":"EnergyUnitTable_formItemStyles__6K9r8"};